import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IShop } from "src/domain/entities"
import { ShopListView } from "."

interface Props {
	list: IShop[]
	isLoading: boolean
	onUpdate: (shop: IShop) => void
	onDelete: (shop: IShop) => void
	onAddClick: () => void
}

export const ShopListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return <BlankStateSection message="No shops found." onAddClick={onAddClick} />
	}

	return <ShopListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
